// eslint-disable-next-line no-unused-vars
import { createSlice, createAsyncThunk, current } from '@reduxjs/toolkit';
import { requestStarted, requestFinished } from '~/stores/redux/common/loadingSlice';
import keywordApi from './keyword.api';
import togglePublishedState from '~/api/togglePublishedState.api';
import { showToast } from '~/utils/helpers';
import { handleThunkException } from '~/services/thunk.service';

export const fetchKeywordApi = createAsyncThunk('cardSaga/keyword/fetchKeywordApi', async (navigate, { dispatch }) => {
    try {
        dispatch(requestStarted());
        const data = await keywordApi.getAll();

        if (data) {
            dispatch(requestFinished());
            return data;
        }
    } catch (error) {
        handleThunkException(error, dispatch);
    }
});

export const toggleKeywordPublishedStateApi = createAsyncThunk(
    'cardSaga/keyword/toggleKeywordPublishedStateApi',
    async (id, { dispatch }) => {
        try {
            await togglePublishedState(id);

            return id;
        } catch (error) {
            handleThunkException(error, dispatch);
        }
    },
);

export const createNewKeywordApi = createAsyncThunk(
    'cardSaga/keyword/createNewKeywordApi',
    async (params, { dispatch }) => {
        const { navigate, values, formikBag, setShowModal } = params;
        try {
            dispatch(requestStarted());
            const keyword = await keywordApi.store(values);
            dispatch(requestFinished());

            showToast('Keyword updated successfully!');
            formikBag.resetForm();
            setShowModal(false);

            return keyword;
        } catch (error) {
            handleThunkException(error, dispatch, navigate);
        }
    },
);

export const updateKeywordApi = createAsyncThunk('cardSaga/keyword/updateKeywordApi', async (params, { dispatch }) => {
    const { navigate, id, values, formikBag, setShowModal } = params;
    try {
        dispatch(requestStarted());
        await keywordApi.update(id, values);
        dispatch(requestFinished());

        showToast('Keyword updated successfully!');
        formikBag.resetForm();
        setShowModal(false);

        return {
            id: values.id,
            name: values.name,
            description: values.description,
        };
    } catch (error) {
        handleThunkException(error, dispatch, navigate);
    }
});

export const deleteKeywordApi = createAsyncThunk('cardSaga/keyword/deleteKeywordApi', async (params, { dispatch }) => {
    const { navigate, id } = params;

    try {
        await keywordApi.delete(id);

        return id;
    } catch (error) {
        handleThunkException(error, dispatch, navigate);
    }
});

export const keywordSlice = createSlice({
    name: 'cardSaga/keyword',
    initialState: { rows: [] },
    extraReducers: (builder) => {
        builder.addCase(fetchKeywordApi.fulfilled, (state, { payload }) => {
            return {
                ...state,
                rows: payload,
            };
        });

        builder.addCase(toggleKeywordPublishedStateApi.fulfilled, (state, { payload }) => {
            const updateRow = state.rows.find((row) => row.id === payload);
            updateRow.is_ready = !updateRow.is_ready;
        });

        builder.addCase(createNewKeywordApi.fulfilled, (state, { payload }) => {
            state.rows.unshift(payload);
        });

        builder.addCase(updateKeywordApi.fulfilled, (state, { payload }) => {
            if (state.rows.length === 0) return;

            state.rows.forEach((item, i, arr) => {
                if (item.id === payload.id) {
                    arr[i] = payload;
                }
            });
        });

        builder.addCase(deleteKeywordApi.fulfilled, (state, { payload }) => {
            return {
                ...state,
                rows: state.rows.filter(({ id }) => id !== payload),
            };
        });
    },
});
